import React from "react";
import { FormattedMessage } from "react-intl";

const InjectMassage = (props) => <FormattedMessage {...props} />;
export default InjectMassage;
